module.exports = __webpack_public_path__ + "static/media/Q4_Back_Right.114b1716.png";